import React, {Component} from 'react';

import {AgencyProfileContent} from "./AgencyProfileContent";

export class AgencyProfile extends Component {
    render() {
        return (
            <AgencyProfileContent />
        )
    }
}

